import {Component, inject, Input} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Table } from '@primeng/table';
import { PTableCellValueComponent } from '@primeng/table/components/p-table-cell-value/p-table-cell-value.component';
import { PaymentStatusBadgeDirective } from '@common/directive/payment-status.directive';
import { MoneyFormatPipe } from '@common/pipe/money-format.pipe';
import {Router} from '@angular/router';
import {TooltipModule} from '@primeng/tooltip';
import { SharedModule } from '@primeng/api';
import { BalanceService } from '@modules/universal-billing/renters/renters-details/balance/balance.service';
import { Renters } from '@modules/universal-billing/renters/renters.interfaces';
import { RenterNamePipe } from '@common/pipe/renter-name.pipe';
import { Balance } from '@modules/universal-billing/renters/renters-details/balance/balance.interfaces';
import { Observable } from 'rxjs';
import { ModalClose } from '@shared/services/modal/modal.enum';
import { ModalService } from '@shared/services/modal/modal.service';
import {
  BalanceFormComponent
} from '@modules/universal-billing/renters/renters-details/balance/balance-form/balance-form.component';
import { ButtonModule } from '@primeng/button';
import { RippleModule } from '@primeng/ripple';
import { RowToggler } from '@primeng/table/directives/row-toggler.directive';
import { BasicTableComponent } from '@common/references/basic-table.component';
import { PageResult } from '@shared/components/classes/page-result';
import { SelectableRow } from '@primeng/table/directives/selectable-row.directive';
import { NgClass, NgIf } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { PaymentsService } from '@modules/universal-billing/accounting/payments/payments.service';
import { Payment } from '@modules/universal-billing/accounting/payments/payments.interfaces';
import { Apartment } from '@modules/universal-billing/apartments/apartments.interface';


@Component({
  selector: 'app-balances',
  standalone: true,
  imports: [
    TranslatePipe,
    MoneyFormatPipe,
    PTableCellValueComponent,
    PaymentStatusBadgeDirective,
    Table,
    TooltipModule,
    SharedModule,
    RenterNamePipe,
    ButtonModule,
    RippleModule,
    RowToggler,
    SelectableRow,
    NgClass,
    NgIf,
    NgbTooltip
  ],
  templateUrl: './balance.component.html',
  styleUrl: './balance.component.scss'
})
export class BalanceComponent extends BasicTableComponent<Balance>{
  @Input() renter: Renters;
  @Input() apartment: Apartment;

  router = inject(Router);
  service = inject(BalanceService);
  paymentService = inject(PaymentsService);
  breadCrumbItems!: Array<{}>;
  modalService: ModalService = inject(ModalService);
  public expandedRows: { [key: string]: boolean } = {};

  ngOnInit(): void {
    this.breadCrumbItems = [{label: 'MENU.UNIVERSAL_BILLING'}, {label: 'MENU.PAYMENTS', active: true}];
    super.ngOnInit();
  }

  toggleRow(row: any) {
    this.expandedRows[row.id] = !this.expandedRows[row.id];
  }

  isExpanded(row: any): boolean {
    return this.expandedRows[row.id];
  }

  getAll(params: any): Observable<PageResult<Balance>> {
    params.renterId = this.renter?.id;
    params.apartmentId = this.apartment?.id;
    return super.getAll(params);
  }

  addBalance(data: Balance) {
    this.modalService.open({
      component: BalanceFormComponent,
      title: 'BALANCE.ADD_BALANCE',
      componentOptions: {
        balance: data
      },
      modalOptions: {
        size: 'lg',
        scrollable: false
      }
    }).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.loadData();
      }
    })
  }
  editPayment(balance: Balance, payment: Payment) {
    this.modalService.open(
      {
        component: BalanceFormComponent,
        title: 'BALANCE.EDIT_BALANCE',
        componentOptions: {
          selectedRow: payment,
          isEdit: true,
          balance: balance
        },
        modalOptions: {
          size: 'lg',
          scrollable: false
        }
      }
    ).then((res) => {
      if (res == ModalClose.SUCCESS) {
        this.loadData();
      }
    }).catch((err) => {})
  }

  onDelete(data: any) {
    this.confirmModalService.open().then((res) => {
      if (res) {
        this.paymentService
          .delete(data.id)
          .subscribe(() => {
            this.sweetAlertService.success('', 'TOAST.TOAST_DELETE');
            this.loadData();
          }, error => this.alertErrorMessage(error?.error?.message))
      }
    })
  }
}
